import type { PostCategory, UserRole } from '../types';

export interface ComposerDefaults {
  category: PostCategory;
  isAnonymous: boolean;
}

const STANDARD: ComposerDefaults = { category: 'progress', isAnonymous: false };
const SCOUT: ComposerDefaults = { category: 'risk', isAnonymous: true };

/**
 * Starting category and anonymity for a NEW observation.
 *
 * Fire Scouts are out looking for hazards on other people's property, so the
 * composer opens on Risk with their name off (Glenn, July 30 2026: "for the
 * typical fire scout, it would be helpful to default to anonymous and risk").
 * Any other role, or no roles at all, keeps the attributed Progress default.
 *
 * Visibility is not part of this: the ask was anonymity, not privacy, and a
 * claimed structure's `defaultPostVisibility` still owns that field.
 * Editing an existing post ignores these entirely.
 */
export function getComposerDefaults(roles: UserRole[] | undefined): ComposerDefaults {
  return roles?.includes('fire-scout') ? SCOUT : STANDARD;
}
